import { render, staticRenderFns } from "./SliderValue.vue?vue&type=template&id=4d23f8b1&scoped=true&"
import script from "./SliderValue.vue?vue&type=script&lang=js&"
export * from "./SliderValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23f8b1",
  null
  
)

export default component.exports